/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import { compose, AnyAction } from "redux";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { PartialAppState, saveSettings } from "store/secret-mode/secret-mode";
import Button from "components/button/button";
import Header from "components/header/header";

interface StateProps {
  isSaveButtonEnabled: boolean;
}

interface DispatchProps {
  saveSettings: () => void;
}

type SecretModeHeaderProps = StateProps & DispatchProps;

export const SecretModeHeader: React.FC<SecretModeHeaderProps> = ({ saveSettings, isSaveButtonEnabled }) => {
  return (
    <Header>
      {isSaveButtonEnabled && (
        <Button variant="success" type="primary" onClick={saveSettings}>
          {t("save")}
        </Button>
      )}
    </Header>
  );
};

const mapStateToProps = (state: PartialAppState) => ({
  isSaveButtonEnabled: state.secretMode.ui.isSaveButtonEnabled
});

const mapDispatchToProps = (dispatch: ThunkDispatch<PartialAppState, void, AnyAction>) => ({
  saveSettings: () => dispatch(saveSettings())
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(SecretModeHeader);
